<template>
  <el-dialog
    :title="'【预览】' + fileData.name"
    :visible.sync="fileViewVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
    width="60%"
  >
    <img
      class="img-body"
      :src="fileData.url"
    />
    <div slot="footer">
      <el-button class="close-button" type="primary" @click="closeDialog" round>关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'view-file-dialog',
  data() {
    return {
      fileViewVisible: false,
      fileData: {
        name: '',
        url: '',
        path: '',
      },
    }
  },
  methods: {
    // 显示弹窗
    showDialog(item) {
      this.fileData = item;
      this.fileViewVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.fileViewVisible = false;
      this.fileData = {
        name: '',
        url: '',
        path: '',
      };
    },
  }
}
</script>

<style scoped lang="less">
::v-deep .el-dialog__body {
  padding: 10px 10px 80px 10px !important;
  height:~'calc(70vh)';
  overflow-y: auto;
}

::v-deep .el-dialog__header {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

::v-deep .el-dialog__footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-color: white;
  padding: 10px;
  text-align: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  .close-button {
    width: 240px;
    font-weight: bold;
    font-size: 18px;
  }
}
.img-body {
  width: 60%;
  height: auto;
}

</style>
